<div class="header">
  <header class="h-100">
    <div class="header-container d-flex justify-content-between align-items-center h-100">
      <a routerLink="''">
        <img class="logo" src="assets/icons/cpit-logo.svg" alt="Cpit Logo" />
      </a>
      <div class="h-100">
        <ul>
          @for (link of links; track link) {
            <li>
              <a [routerLink]="link.url" routerLinkActive="active">{{ link.title }}</a>
            </li>
          }
        </ul>
      </div>
      <div class="d-flex align-items-center">
        <div class="text">{{ userEmail$ | async }}</div>
        <button [matMenuTriggerFor]="logout" class="button-icon-transparent-24px">
          <img src="assets/icons/chevron-icon.svg" alt="More Options Icon" width="24" height="24" />
        </button>
        <mat-menu #logout="matMenu" class="logout-menu">
          <div mat-menu-item (click)="logOut()">Ausloggen</div>
        </mat-menu>
      </div>
    </div>
  </header>
</div>
